import { Modal } from 'react-bootstrap';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import { ActionButton } from 'app/components/Button/ActionButton';
import Typography from 'app/components/Typography';

import { StatusItem } from 'app/modules/inventory/items/core/constants';
import { changeStatusItem, getItem } from 'app/modules/inventory/items/core/requests';
import { Item } from 'app/modules/inventory/items/core/type';

export const ModalContainer = styled(Modal)`
  .modal-body {
    padding-bottom: 0;
  }

  .modal-footer {
    border: none;
    padding-top: 0;
  }
`;

interface ItemStatusModalProps {
  open: boolean;
  item: Item | null;
  setItem: (item: Item | null) => void;
  onCancel: () => void;
}
const ItemStatusModal: React.FC<ItemStatusModalProps> = ({ item, open, setItem, onCancel }) => {
  const isInactive = item?.status === StatusItem.Inactive;
  const isUnableInActivateItem = Boolean(item?.hasStockRun) || item?.bins?.length;
  const title = isInactive ? 'Activate' : 'Inactivate';

  const { mutate: changeStatusItemMutation, isLoading: isSubmitting } = useMutation({
    mutationFn: () =>
      changeStatusItem(item?.id, {
        activate: isInactive ? StatusItem.Active : StatusItem.Inactive,
      }),
    onSuccess: async () => {
      const newItem = await getItem('page=1&limit=10&orderBy=ward&orderDirection=ASC', item?.id);
      setItem(newItem || null);
      onCancel();
      toast.success(`${title} item successfully!`);
    },
  });

  const renderMessage = () => {
    if (isUnableInActivateItem)
      return 'To inactivate this item, it has to be removed from all the bins.';

    if (!isInactive)
      return 'After inactivating this item, you won’t be able to assign it to a bin. You can activate it back later.';

    return 'Are you sure to Activate this item?';
  };

  const handleSubmit = () => {
    changeStatusItemMutation();
  };

  return (
    <ModalContainer show={open} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <Typography variant="heading-6">{title} item</Typography>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Typography variant="body-3">{renderMessage()}</Typography>
      </Modal.Body>
      <Modal.Footer>
        <ActionButton
          labelButtonSubmit={title}
          onSubmit={handleSubmit}
          onCancel={onCancel}
          isSubmitting={isSubmitting}
          themeButton={!isUnableInActivateItem && !isInactive ? 'btn-danger' : 'btn-primary'}
          isShowButtonReset={!isUnableInActivateItem}
        />
      </Modal.Footer>
    </ModalContainer>
  );
};

export default ItemStatusModal;
